import { createContext, useContext } from 'react';
import type { Habit, HabitInput } from '../../shared/api';

export interface EditorApi {
  openNew: (template?: HabitInput) => void;
  openEdit: (habit: Habit) => void;
}

export const EditorContext = createContext<EditorApi>({ openNew: () => {}, openEdit: () => {} });

export const useEditor = () => useContext(EditorContext);
